<template>
  <div class="sub-nav" v-if="showSubNav">
    <div class="sub-nav-container">
      <div class="sub-nav-content">
        <router-link
          v-for="item in filteredSubNavItems"
          :key="item.path"
          :to="item.path"
          :class="['sub-nav-item', { active: $route.path === item.path }]"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SubNav',
  computed: {
    ...mapGetters(['merchant', 'permissions']),
    showSubNav() {
      return !this.$route.path.startsWith('/dashboard')
    },
    isMerchant() {
      return this.merchant?.user_type === 'merchant'
    },
    subNavItems() {
      const routeMap = {
        '/deposit': [
          { path: '/deposit/orders', title: '收款记录', permission: 'can_view_deposit' },
          { path: '/deposit/create', title: '发起收款', permission: 'can_create_deposit' },
          { path: '/deposit/channels', title: '收款通道', permission: 'can_view_deposit' },
          { path: '/deposit/cashier', title: '收银台', permission: 'can_view_deposit' }
        ],
        '/payout': [
          { path: '/payout/orders', title: '下发订单', permission: 'can_view_payout' },
          { path: '/payout/create', title: '发起下发', permission: 'can_create_payout' },
          { path: '/payout/batch', title: '批量下发', permission: 'can_create_payout' },
          { path: '/payout/receivers', title: '收款人管理', permission: 'can_view_payout' }
        ],
        '/application': [
          { path: '/application/list', title: '进件列表', permission: 'can_view_application' },
          { path: '/application/create', title: '新建进件', permission: 'can_create_application' }
        ],
        '/settlement': [
          { path: '/settlement/summary', title: '结算汇总', permission: 'can_view_settlement' },
          { path: '/settlement/records', title: '结算记录', permission: 'can_view_settlement' }
        ],
        '/account': [
          { path: '/account/index', title: '账户信息', permission: null },
          { path: '/account/subaccounts', title: '子账号管理', permission: 'can_view_subaccount' }
        ],
        '/developer': [
          { path: '/developer/apikeys', title: 'API密钥', permission: 'can_view_developer' },
          { path: '/developer/callback', title: '回调配置', permission: 'can_view_developer' },
          { path: '/developer/docs', title: 'API文档', permission: 'can_view_developer' }
        ]
      }
      
      const currentPath = this.$route.path
      for (const [parentPath, items] of Object.entries(routeMap)) {
        if (currentPath.startsWith(parentPath)) {
          return items
        }
      }
      return []
    },
    filteredSubNavItems() {
      if (this.isMerchant) return this.subNavItems
      return this.subNavItems.filter(item => {
        if (!item.permission) return true
        const value = this.permissions?.[item.permission]
        return value === true || value === 1 || value === '1'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-nav {
  position: fixed;
  top: 72px;
  left: 0;
  right: 0;
  z-index: 900;
  background: rgba(14, 14, 18, 0.9);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.sub-nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 32px;
}

.sub-nav-content {
  display: flex;
  gap: 4px;
  padding: 8px 0;
}

.sub-nav-item {
  padding: 10px 20px;
  color: var(--text-muted);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.05);
  }

  &.active {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.08);
  }
}
</style>
